import { Component, Input, OnInit, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http'; // 1. IMPORTA HttpClient

@Component({
  selector: 'app-instagram-post',
  standalone: true,
  imports: [CommonModule, HttpClientModule], 
  templateUrl: './instagram-post.component.html',
  styleUrls: ['./instagram-post.component.scss']
})
export class InstagramPostComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);
  private http = inject(HttpClient);
  @Input() post: any;

  mostrarModal: boolean = false;
  cargando: boolean = false; 

  ngOnInit() {
  }
  iframeUrlSafe: SafeResourceUrl | null = null;

  abrirModal() {
    if (!this.post?.permalink) return; 

    const permalink = this.post.permalink || this.post.postPermalink;
    const baseUrl = permalink.endsWith('/') ? permalink : `${permalink}/`;
    const urlEmbed = `${baseUrl}embed/`;

    this.iframeUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(urlEmbed);
    this.mostrarModal = true;
  }

  cerrarModal() {
    this.mostrarModal = false;
  }
}